import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetVerifyCode, verifyAccount } from '../api/services/AuthService';
import { ErrorToast, SuccessToast } from '../utils/toasters';
import { actions } from '../store/authentication/AuthSlice';

export function VerificationPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useSelector((state: any) => state?.auth);
    const codeInputRef = useRef<HTMLInputElement | null>(null);

    const [confirmationToken, setConfirmationToken] = useState({
        twoFactorToken: '',
    });

    const resendVerify = () => {
        setIsLoading(true);
        resetVerifyCode(user?.email ?? '')
            .then(() => {
                SuccessToast('Please check your email for the verification code');
            })
            .catch(error => ErrorToast(error))
            .finally(() => setIsLoading(false));
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setConfirmationToken(prev => ({ ...prev, [name]: value }));
    };

    function onSubmit(event: React.FormEvent<HTMLFormElement | (EventTarget & HTMLElement)>) {
        event.preventDefault();
        verifyAccount(user.twoFactorUUID, confirmationToken.twoFactorToken)
            .then(() => {
                dispatch(actions.verify());
                navigate('/');
            })
            .catch(err => ErrorToast(err));
    }

    useEffect(() => {
        if (codeInputRef?.current) {
            codeInputRef?.current.focus();
        }
    }, []);

    return (
        <Card className="mb-5">
            <Form
                as={Card.Body}
                onKeyDown={(e: any) => {
                    if (e.key === 'Enter') onSubmit(e);
                }}
            >
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <img alt="Verifaid img" src="/icons/verified.png" />
                    <h3 className="mt-5">Verify your account</h3>
                    <p className="text-muted">
                        Enter the code received in your E-Mail:
                        <br />
                        {user?.email}
                    </p>
                </div>
                <Row>
                    <Form.Group as={Col} className="mt-4 mb-0">
                        <Form.Control
                            required
                            ref={codeInputRef}
                            placeholder="Code*"
                            min={4}
                            type="number"
                            defaultValue={confirmationToken?.twoFactorToken}
                            name="twoFactorToken"
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Row>
                <div>
                    <span className="text-muted">Do not forget to check your Spam Folder.</span>
                    <div className="d-flex justify-content-between align-items-center my-5">
                        <div
                            className="btn btn-link d-flex align-items-center justify-content-end"
                            onClick={() => resendVerify()}
                        >
                            {isLoading ? (
                                <>
                                    Loading... <Spinner animation="border" size="sm" role="status" className="ml-1" />
                                </>
                            ) : (
                                'Re-Send'
                            )}
                        </div>
                        <Button
                            disabled={confirmationToken.twoFactorToken.length < 4}
                            type="submit"
                            onClick={event => onSubmit(event)}
                            variant="outline-primary"
                            size="sm"
                        >
                            Verify
                        </Button>
                    </div>
                </div>
            </Form>
        </Card>
    );
}
